export default __webpack_public_path__ + "static/media/check-circle.cd9ed70a.svg";